import CONSTANTS from "@/store/constants";

const EXCEPTION_SUBMISSION_CONSTANTS = {
    TAB_ITEMS: [
        {
            name: `General information`,
            component: "GeneralInformationForExceptionRequest",
        },
        {
            name: `Supplier Information `,
            component: "SupplierInformationForExceptionRequest"
        },
        {
            name: "Preview Invoice submission",
            component: "PreviewDetailsForExceptionRequest",
        }
    ],
    REQUEST_FOR_MAP: {
        SPONSORSHIP: CONSTANTS.EXCEPTION_SUBMISSION_REQUEST_FOR_MAP.SPONSORSHIP,
        SPONSORSHIP_URL: "https://employeehub.autodesk.com/LEGAL-MARKETING-TOOLKIT/articles/ad26c577db508150bb65819b1396195e",
        CORPORATE_DONATION: CONSTANTS.EXCEPTION_SUBMISSION_REQUEST_FOR_MAP.CORPORATE_DONATION,
        DONATION_URL: "https://employeehub.autodesk.com/PTP/articles/b7a9cc981bc428901a22ba651a4bcbad",
        SPEAKER: CONSTANTS.EXCEPTION_SUBMISSION_REQUEST_FOR_MAP.SPEAKER,
        SPEAKER_URL: "https://employeehub.autodesk.com/LEGAL-MARKETING-TOOLKIT/articles/d5f2137bdbd0c150bb65819b13961911",
        OTHER: CONSTANTS.EXCEPTION_SUBMISSION_REQUEST_FOR_MAP.OTHER,
        ADSK_CONSULTING_ENGAGEMENTS: CONSTANTS.EXCEPTION_SUBMISSION_REQUEST_FOR_MAP.ADSK_CONSULTING_ENGAGEMENTS,
        RENT_UTILITIES: CONSTANTS.EXCEPTION_SUBMISSION_REQUEST_FOR_MAP.RENT_UTILITIES,
        LEGAL_SERVICES: CONSTANTS.EXCEPTION_SUBMISSION_REQUEST_FOR_MAP.LEGAL_SERVICES,
        GENERIC_CHECKBOX_URL: "https://employeehub.autodesk.com/PTP/articles/f201c05b1b8085505002ea45624bcbfa"
    },
    REQUEST_FOR_CHECKBOX_TEXT:{
        CORPORATE_DONATION_TEXT:"I have completed the steps required for Corporate donations and I am ready with my approved, signed donation letter to complete my purchase.",
        SPONSORSHIP_TEXT: "I have completed the steps required for Sponsorships and I am ready with my approved, signed agreement to complete my purchase.",
        SPEAKER_TEXT: "I have an Autodesk-approved, signed agreement and I am ready to complete my purchase.",
        GENERIC_CHECKBOX_TEXT: "I have completed the necessary steps and I am ready with the supporting documentation to complete my purchase.",
        OTHER_TEXT: "Describe why this request is considered an exception to the standard Supplier Central intake process"
    },
    REQUEST_FOR_OPTIONS: [
        {
            value: "0",
            text: CONSTANTS.EXCEPTION_SUBMISSION_REQUEST_FOR_MAP.ADSK_CONSULTING_ENGAGEMENTS
        },
        {
            value: "1",
            text: CONSTANTS.EXCEPTION_SUBMISSION_REQUEST_FOR_MAP.CORPORATE_DONATION
        },
        {
            value: "2",
            text: CONSTANTS.EXCEPTION_SUBMISSION_REQUEST_FOR_MAP.LEGAL_SERVICES
        },
        {
            value: "3",
            text: CONSTANTS.EXCEPTION_SUBMISSION_REQUEST_FOR_MAP.RENT_UTILITIES
        },
        {
            value: "4",
            text: CONSTANTS.EXCEPTION_SUBMISSION_REQUEST_FOR_MAP.SPEAKER
        },
        {
            value: "5",
            text: CONSTANTS.EXCEPTION_SUBMISSION_REQUEST_FOR_MAP.SPONSORSHIP
        },
        {
            value: "6",
            text: CONSTANTS.EXCEPTION_SUBMISSION_REQUEST_FOR_MAP.OTHER
        }
    ],
    COUNTRY_US: "US",
    AUTODESK_BUYING_SERVICES: `If you do not know, refer to the first 4 numbers of your cost center. 
    Select all companies related to your engagement. 
    The Autodesk company choosen should be the company that will benefitiate from the services 
    (i.e Global project = Autodesk Inc, EMEA = Autodesk Ireland, local = the country).`,
    SUBMISSION_BASE_QUERY: {
        API: `/api/now/table/u_adsk_vendor_onboarding`,
        SYSPARM_FIELDS: `?sysparm_fields=u_request_ritm,sys_id,u_request_ritm.number`
    },
    EXIT_POINT: "exception request"
}

export default EXCEPTION_SUBMISSION_CONSTANTS